import React from 'react';
import CommunicationTable from './components/communicationTable';

const index = () => {
    return (
        <div>
            <CommunicationTable />
        </div>
    );
};

export default index;
